import { Button, IconButton, Tooltip } from '@chakra-ui/react';
import { FiArrowLeft, FiEdit, FiTrash2, FiLink } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

interface ProjectHeaderProps {
  isEditing: boolean;
  onSave: () => void;
  onCancel: () => void;
  onToggleEdit: () => void;
  onDelete: () => void;
  onShare: () => void;
  navigateBack: () => void;
}

export const ProjectHeader: React.FC<ProjectHeaderProps> = ({
  isEditing,
  onSave,
  onCancel,
  onToggleEdit,
  onDelete,
  onShare,
  navigateBack
}) => {
  const { t } = useTranslation(['v0/projects', 'v0/common']);

  return (
    <div className="flex justify-between items-center mb-4 md:mb-6 flex-wrap md:flex-nowrap gap-3">
      <Button
        leftIcon={<FiArrowLeft />}
        variant="ghost"
        onClick={navigateBack}
        size={{ base: 'sm', md: 'md' }}
      >
        {t('v0/projects:actions.backToList')}
      </Button>

      <div className="flex gap-2">
        {isEditing ? (
          <>
            <Button
              colorScheme="teal"
              onClick={onSave}
              size={{ base: 'sm', md: 'md' }}
            >
              {t('v0/common:actions.save')}
            </Button>
            <Button
              onClick={onCancel}
              size={{ base: 'sm', md: 'md' }}
            >
              {t('v0/common:actions.cancel')}
            </Button>
          </>
        ) : (
          <>
            <Tooltip label={t('v0/projects:actions.editProject')} hasArrow>
              <IconButton
                aria-label={t('v0/projects:actions.editProject')}
                icon={<FiEdit />}
                onClick={onToggleEdit}
                colorScheme="blue"
                variant="ghost"
                size={{ base: 'sm', md: 'md' }}
              />
            </Tooltip>
            <Tooltip label={t('v0/projects:actions.shareProject', '分享项目')} hasArrow>
              <IconButton
                aria-label={t('v0/projects:actions.shareProject', '分享项目')}
                icon={<FiLink />}
                onClick={onShare}
                colorScheme="green"
                variant="ghost"
                size={{ base: 'sm', md: 'md' }}
              />
            </Tooltip>
            <Tooltip label={t('v0/projects:actions.deleteProject')} hasArrow>
              <IconButton
                aria-label={t('v0/projects:actions.deleteProject')}
                icon={<FiTrash2 />}
                onClick={onDelete}
                colorScheme="red"
                variant="ghost"
                size={{ base: 'sm', md: 'md' }}
              />
            </Tooltip>
          </>
        )}
      </div>
    </div>
  );
};